import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { initI18n } from './i18n.js';
import { readParams, resolveLocale } from './lib/params.js';
import { startHeightReporting } from './lib/embedHost.js';
import './index.css';

/**
 * Widget entry point.
 *
 * The locale is resolved and `<html lang/dir>` set BEFORE React mounts, so an
 * Arabic guest never sees a frame of left-to-right layout. On a 3G connection
 * that frame would be visible for a noticeable moment.
 */
const container = document.getElementById('widget-root');
if (!container) throw new Error('#widget-root missing from index.html');

const params = readParams();

// `?lang=` wins over the browser: an Arabic QR code on a table tent, or a link
// inside an Arabic WhatsApp confirmation, must open in Arabic whatever the
// phone is set to.
const locale = resolveLocale(params.locale, 'en');

void initI18n(locale).then(() => {
  // Tell a host page how tall we are, if we are inside one. A no-op otherwise.
  startHeightReporting();

  createRoot(container).render(
    <StrictMode>
      <App params={params} />
    </StrictMode>,
  );
});
